import React from 'react';
import { GQL } from '@gin-betting/core';

import { AsyncBetslipFreebet } from 'modules/freebet/async';
import BetslipStakeInput from '../../BetslipStakeInput';
import PlaceBet from '../../PlaceBet';
import BetDetails, { TotalType } from '../BetDetails';
import useSinglePart from './useSinglePart';

import './singlePartMob.scss';

interface Props {
    betslipBetId: string;
    button?: JSX.Element;
}

const SinglePartMob: React.FC<Props> = ({ betslipBetId, button }) => {
    const {
        singleStake,
        isFreebet,
        totals: { totalWin },
        maxStake,
        changeStakeHandler,
        betslipOddIds,
        isSuspended,
    } = useSinglePart({ betslipBetId });

    return (
        <React.Fragment>
            <AsyncBetslipFreebet
                toggleFreebetCallback={changeStakeHandler}
                betslipOddIds={betslipOddIds}
                betType={GQL.BetType.SINGLE}
                isFreebetInProcess={isSuspended}
            />
            <div
                styleName="container"
                className="__app-SinglePartMob-container"
            >
                {!isFreebet && (
                    <BetslipStakeInput
                        maxStake={maxStake}
                        changeValue={changeStakeHandler}
                        value={singleStake}
                        isDisabled={isFreebet}
                    />
                )}
                <BetDetails
                    total={singleStake}
                    totalType={TotalType.stake}
                    totalWin={totalWin}
                />
                <div styleName="buttons">
                    <PlaceBet
                        betslipBetId={betslipBetId}
                        isFreebetActive={isFreebet}
                        totalStake={+singleStake}
                    />
                    {button}
                </div>
            </div>
        </React.Fragment>
    );
};

export default React.memo(SinglePartMob);
